import { AbstractModel } from '@patsnap/tahiti-core';
import { FtoReportTaskStatusModel } from '../task-status-model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TaskStatus } from '@/domains/task/enums';
import { FtoTaskStep } from '../../enums';
import type { FtoReportTaskStatus } from '../../types';

function createInitialTaskStatus(): FtoReportTaskStatus {
    return {
        taskStatus: TaskStatus.READY,
        taskStep: FtoTaskStep.INITIAL,
        lastUpdateTime: '',
        userInput: '',
        inputLanguage: '',
        isHistoryData: false,
    };
}

@injectable()
export class FtoReportTaskStatusModelImpl extends AbstractModel<FtoReportTaskStatus> implements FtoReportTaskStatusModel {
    protected _modelData: FtoReportTaskStatus = createInitialTaskStatus();

    dispose(): void {
        this.update(() => createInitialTaskStatus());
    }
}
